module.exports = __webpack_public_path__ + "img/ITT-logo.67bf4ed9.jpg";